import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import { minDate } from "../../Constants/Constants";

const AddMaterialIncoming = ({ setimgfile, formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [party, setParty] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [company, setCompany] = useState([]);
  const [partyNameId, setPartyNameId] = useState("");
  const [partyName, setPartyName] = useState([]);
  const [unit, setUnit] = useState("");
  const [materialName, setMaterialName] = useState([]);
  const [materialNameId, setMaterialNameId] = useState({});
  const [rowAddData, setRowAddData] = useState({
    company_id: "",
    party_name_id: "",
    material_name: "",
    incoming: "",
    date: "",
  });
  const [incomingList, setIncomingList] = useState([
    { party_name_id: "", incoming: "" },
  ]);
  // console.log(partyName)
  function resetFileds() {
    setRowAddData({
      company_id: "",
      party_name_id: "",
      material_name: "",
      incoming: "",
      date: "",
    });
    setSelectedCompanyId("");
    setMaterialNameId("");
    setPartyName([]);
    setIncomingList([{ party_name_id: "", incoming: "" }]);
  }
  const handlePartyChange = (e) => {
    setPartyNameId(e.target.value);
  };

  const handleMaterialChange = (e) => {
    setMaterialNameId(e.target.value);
  };

  const handleCompanyChange = (e) => {
    setSelectedCompanyId(e.target.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { incoming, date } = rowAddData;
    let BASE_URL =
      SERVER_URL + `/api/mat-incoming/material-incoming/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        // party_name_ids: [partyNameId],
        incoming_details: incomingList,
        company_id: selectedCompanyId,
        material_name_id: materialNameId,
        date: moment.utc(date, "YYYY-MM-DD").toISOString(),
        // incomings: [incoming],
      }),
    });
    const response = await res.json();

    if (res.ok) {
      // console.log(response);
      setIncomingList([{ party_name_id: "", incoming: "" }]);
      resetFileds();
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getSinglePartyName = async (e) => {
    setMaterialNameId(e.target.value);
    let BASE_URL = SERVER_URL + `/api/party/drop-partyName/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
        material_name_id: e.target.value,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setPartyName(response.data);
    } else {
      toast.error(response.message);
    }
  };

  const getMaterialName = async () => {
    const BASE_URL =
      SERVER_URL + `/api/raw-mat-name/all-material-names/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setMaterialName(result.data);
    } else {
      setMaterialName([]);
    }
  };

  useEffect(() => {
    getMaterialName();
  }, []);

  const handleUnitChange = (e) => {
    setUnit(e.target.value);
  };

  const handleAddFields = () => {
    setIncomingList([...incomingList, { party_name_id: "", incoming: "" }]);
  };

  const handleChangeInput = (index, event) => {
    const values = [...incomingList];
    if (event.target.name === "party_name_id") {
      values[index].party_name_id = event.target.value;
    } else {
      values[index].incoming = event.target.value;
    }
    setIncomingList(values);
  };

  const handleClose = (index) => {
    const values = [...incomingList];
    values.splice(index, 1);
    setIncomingList(values);
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Material Incoming
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Raw Material</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="Company_Name">
                              Raw Material Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="material_name"
                              id="Company_Name"
                              placeholder="Raw Material Name"
                              onChange={handleChange}
                            />
                          </div>
                        </div> */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_name">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={selectedCompanyId}
                              id="company_name"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="material_name">Material Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={getSinglePartyName}
                              value={materialNameId}
                              id="material_name"
                              required
                            >
                              <option value="">Select Material</option>
                              {materialName &&
                                materialName?.length &&
                                materialName?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.material_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="date"
                              id="date"
                              placeholder="Date"
                              min={minDate}
                              max={new Date().toISOString().split("T")[0]}
                              value={rowAddData.date}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className="row">
                      <div className="col-md-6">
                          <div className="form-group">
                            <label>Party Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handlePartyChange}
                              value={partyNameId}
                            >
                              <option>Select</option>
                              {partyName?.map((item, id) => {
                                return (
                                  <>
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.party_name}`}</option>
                                  </>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="Incoming">Incoming</label>
                            <input
                              type="text"
                              className="form-control"
                              name="incoming"
                              id="Incoming"
                              placeholder="Incoming"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div> */}
                      {incomingList &&
                        incomingList.length > 0 &&
                        incomingList?.map((inputField, index) => (
                          <div className="row" key={index}>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="party_name">Party Name</label>
                                <select
                                  className="form-control form-control-lg"
                                  onChange={(event) =>
                                    handleChangeInput(index, event)
                                  }
                                  name="party_name_id"
                                  value={inputField.party_name_id}
                                  id="party_name"
                                  required
                                >
                                  <option value="">Select</option>
                                  {partyName.map((item, index) => (
                                    <option
                                      value={`${item.id}`}
                                      key={index}
                                    >{`${item.party_name}`}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="incoming">Incoming</label>
                                <div className="input-group">
                                  <input
                                    type="number"
                                    id="incoming"
                                    className="form-control"
                                    name="incoming"
                                    placeholder="Incoming"
                                    value={inputField.incoming}
                                    onChange={(event) =>
                                      handleChangeInput(index, event)
                                    }
                                    required
                                    min="1"
                                    autoComplete="off"
                                  />
                                  <span className="input-group-append ml-2">
                                    <div className="col-md-2">
                                      {index > 0 ? (
                                        <button
                                          type="button"
                                          title="Remove"
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                          onClick={() => handleClose(index)}
                                        >
                                          <span className="mdi mdi-close-thick"></span>
                                        </button>
                                      ) : (
                                        <button
                                          type="button"
                                          disabled
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                        >
                                          <span className="mdi mdi-close-thick"></span>
                                        </button>
                                      )}
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      <span className="input-group-append ml-2">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleAddFields}
                        >
                          Add More
                        </button>
                      </span>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMaterialIncoming;
